import {combineReducers} from 'redux';
import settingReducer from "../shared/reducers/setting"

const reducers = combineReducers({
    setting: settingReducer,
});

export default reducers
